import { SubscriptionId } from 'modules/payment/subscriptions/types/subscription-interface'
import { PaystackPaymentProcessor } from 'modules/profile/payment-gateways/integrations/paystack/types'
import httpClient from 'shared/utils/http-client'

export const MANAGE_SUBSCRIPTIONS_API = '/api/dashboard/settings/customer-subscriptions'

export const cancelSubscription = (id: number) =>
  httpClient.post(`${MANAGE_SUBSCRIPTIONS_API}/unsubscribe/${id}`)

export const cancelSecureAndPaySubscription = (id: number) =>
  httpClient.delete(`/api/payment/integration/secure-and-pay/subscription/cancel/${id}`)

export const cancelGocardlessSubscription = (id: SubscriptionId) =>
  httpClient.post(`/api/payment/integration/gocardless/subscription/cancel`, {
    subscription: id,
    cancelledManually: true,
    cancelledImmediately: true,
  })

export const cancelXenditSubscription = (id: SubscriptionId) =>
  httpClient.delete(`/api/payment/integration/xendit/subscription/cancel/${id}/immediately`)

export const cancelPaystackSubscription = (
  id: SubscriptionId,
  paymentProcessorName: PaystackPaymentProcessor,
) =>
  httpClient.delete(
    `/api/payment/integration/${paymentProcessorName}/subscription/cancel/${id}/immediately`,
  )

export const cancelPaypalRestSubscription = (id: SubscriptionId) =>
  httpClient.delete(`/api/payment/integration/paypal-rest/subscription/cancel/${id}`)
